import { CompanyContactData } from 'src/Libs/user/models'
import { CompanyForm, CompanyModel } from '../models'

export const modelsToForm = (validatedCountryCode: string, company?: CompanyModel, companyLocation?: CompanyContactData): CompanyForm => ({
  name: company?.name ?? '',
  sapCustomerId: company?.sapCustomerId === -1 ? undefined : company?.sapCustomerId.toString(),
  address: companyLocation?.PlaceOR ?? '',
  zipCode: companyLocation?.PLZ ?? '',
  city: companyLocation?.Address ?? '',
  country: validatedCountryCode,
  phone: companyLocation?.Telefon ?? '',
  fax: companyLocation?.Telefax ?? '',
  email: companyLocation?.Email ?? '',
  shopPermission: company?.shopPermission ?? false,
  partnerNumber: company?.partnerNumber ?? '',
  ndaSubmit: company?.ndaSubmit,
})
